// extracted by mini-css-extract-plugin
export default {"CardSizes":"NewsCard_CardSizes__q59Fd","ImageContainer":"NewsCard_ImageContainer__My2Dv","Badge":"NewsCard_Badge__DveDH","CardContent":"NewsCard_CardContent__NMVl9"};